/* LONGEVX · Carrusel de tarjetas: arrastre con mouse, touch nativo, flechas, progreso y Ken Burns en la tarjeta en lectura. */
if (!customElements.get('lx-rail')) {
  customElements.define('lx-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.prev = this.querySelector('[data-dir="-1"]');
      this.next = this.querySelector('[data-dir="1"]');
      this.bar = this.querySelector('[data-progress]');
      if (!this.track || !this.cards.length) return;

      this.prev?.addEventListener('click', () => this.go(-1));
      this.next?.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => this.queue(), { passive: true });
      window.addEventListener('resize', () => this.queue());
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
      });
      this.initDrag();

      /* Ken Burns solo cuando la sección está en pantalla */
      this.visible = false;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; this.update(); }, { threshold: 0.2 }).observe(this);
      } else { this.visible = true; }
      this.update();
    }

    start() { return parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart) || 0; }

    activeIndex() {
      const left = this.track.getBoundingClientRect().left + this.start();
      let best = 0, dist = Infinity;
      this.cards.forEach((c, i) => {
        const d = Math.abs(c.getBoundingClientRect().left - left);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }

    posOf(i) {
      const t = this.track;
      return t.scrollLeft + (this.cards[i].getBoundingClientRect().left - t.getBoundingClientRect().left) - this.start();
    }

    go(dir) {
      const i = Math.max(0, Math.min(this.cards.length - 1, this.activeIndex() + dir));
      this.track.scrollTo({ left: this.posOf(i), behavior: 'smooth' });
    }

    queue() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); });
    }

    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const idx = max > 8 && t.scrollLeft >= max - 4 ? this.cards.length - 1 : this.activeIndex();
      if (this.prev) this.prev.disabled = t.scrollLeft <= 4;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 4;
      if (this.bar) {
        const ratio = max > 0 ? t.scrollLeft / max : 1;
        const base = 1 / this.cards.length;
        this.bar.style.width = `${Math.min(100, (base + (1 - base) * ratio) * 100)}%`;
      }
      if (idx !== this.current || this.visible !== this.wasVisible) {
        this.cards.forEach((c, i) => c.classList.toggle('is-active', this.visible && i === idx));
        this.current = idx;
        this.wasVisible = this.visible;
      }
    }

    initDrag() {
      const t = this.track;
      let down = false, startX = 0, startLeft = 0, moved = 0, lastX = 0, lastT = 0, vel = 0;
      t.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = 0; startX = lastX = e.clientX; startLeft = t.scrollLeft; lastT = performance.now(); vel = 0;
      });
      window.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (!t.classList.contains('is-dragging') && Math.abs(dx) > 4) t.classList.add('is-dragging');
        if (!t.classList.contains('is-dragging')) return;
        moved = Math.abs(dx);
        const now = performance.now();
        vel = (e.clientX - lastX) / Math.max(1, now - lastT);
        lastX = e.clientX; lastT = now;
        t.scrollLeft = startLeft - dx;
      });
      const end = () => {
        if (!down) return;
        down = false;
        if (!t.classList.contains('is-dragging')) return;
        t.classList.remove('is-dragging');
        /* Encaje a la tarjeta más cercana según la dirección del gesto */
        const idx = this.activeIndex();
        let target = idx;
        if (Math.abs(vel) > 0.35) target = idx + (vel < 0 ? 1 : -1);
        target = Math.max(0, Math.min(this.cards.length - 1, target));
        t.scrollTo({ left: this.posOf(target), behavior: 'smooth' });
      };
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
      /* Evita abrir un enlace después de arrastrar */
      t.addEventListener('click', (e) => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
      t.addEventListener('dragstart', (e) => e.preventDefault());
    }
  });
}
